module.exports = __webpack_public_path__ + "media/images/vp/sample.practice-8ecb3fecce6e5ae14de5b6dd911d727c.jpg";